module.exports = require("js-file-download");


//////////////////
// WEBPACK FOOTER
// external "js-file-download"
// module id = 608
// module chunks = 0